import RegularBuyButton from "./RegularBuyButton";
import ConfigurableProductBuyButton from "./ConfigurableProductBuyButton";
import LogosProductBuyButton from "./LogosProductBuyButton";
import BuyButtonWithNotice from "./BuyButtonWithNotice";

const ListBuyButton = (props) => {
    switch (props.type){
        case 'regular':{
            return RegularBuyButton(props);
        }
        case 'on-demand':{
            return LogosProductBuyButton(props);
        }
        case 'configurable':{
            return ConfigurableProductBuyButton(props);
        }
        default: {
            if(props.comment){
                return BuyButtonWithNotice(props);
            }

            return RegularBuyButton(props);
        }
    }
};

export default ListBuyButton;
